import { render, staticRenderFns } from "./MonitorInfo.vue?vue&type=template&id=1445030a&scoped=true&"
import script from "./MonitorInfo.vue?vue&type=script&lang=js&"
export * from "./MonitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./MonitorInfo.vue?vue&type=style&index=0&id=1445030a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445030a",
  null
  
)

export default component.exports